import { URL_BASE_PAGOS2 } from "../../../constants/url";
import { get, post, postGetFile } from "../../../utils/fetch";

export const getIndicadoresComplementos = (payload) => {
  return post(`${URL_BASE_PAGOS2}/GetIndicadoresOP`, payload);
};

export const getDetalleIndicadorProveedores = (payload) => {
  return post(`${URL_BASE_PAGOS2}/GetDetalleIndicadorProveedores`, payload);
};

export const getIndicadoresComplementosTodos = () => {
  return get(`${URL_BASE_PAGOS2}/GetIndicadoresOP`);
};

export const getDetalleIndicadorProveedoresTodos = () => {
  return get(`${URL_BASE_PAGOS2}/GetDetalleIndicadorProveedores`);
};

export const getXlsDetalleIndicadorProveedores = (payload) => {
  return postGetFile(
    `${URL_BASE_PAGOS2}/GetXlsDetalleIndicadorProveedores`,
    "DetalleIndicadorProveedores.xls",
    payload
  );
};
